import RouteNoteType from "@Route/types/notes/RouteNote.type";

export default function filterCheckOrderCompanySpecificNotes(notes: RouteNoteType[] | undefined) {
    return notes?.filter((note) => note.displayOnCheckOrder === true && note)
}